<div class="fi-alert" [class]="'fi-alert--' + tone" role="status">
  <div class="fi-alert__text">
    <img class="fi-alert__icon" [src]="icon" alt="">
    <span class="fi-alert__message"><ng-content></ng-content></span>
  </div>

  <button *ngIf="actionLabel" type="button" class="fi-alert__action" (click)="action.emit()">
    <span>{{ actionLabel }}</span>
    <img *ngIf="actionIcon" class="fi-alert__action-icon" [src]="actionIcon" alt="">
  </button>

  <button *ngIf="dismissible" type="button" class="fi-alert__close" (click)="dismissed.emit()" aria-label="Close">
    <img src="assets/icons/new/close.svg" alt="">
    <span class="u-hidden-visually" fiTranslation="ALT_TEXT_ALERT_DISMISS"></span>
  </button>
</div>
